import { makeStyles } from '@mui/styles';

import Callout from '@classify/react-core-components/Callout';

import { DisclaimersTeleporter } from 'Modules/layout';
import browser from '@openclassrooms/utils/browser';

const useStyles = makeStyles(
  ({ spacing }) => ({
    root: {
      marginBottom: spacing(3),
    },
  }),
  { classNamePrefix: 'DisclaimersFromTwig' }
);

function DisclaimersFromTwig({ disclaimers }) {
  const classes = useStyles();

  return (
    <DisclaimersTeleporter.Source>
      <div className={classes.root}>
        {disclaimers.map(({ link, message }) => {
          function checkLinks(content) {
            const elementToTransform = content?.querySelector('[data-link]');
            const elementToInsert = browser.document.createElement('a');

            if (!elementToTransform || !elementToInsert) {
              return;
            }

            elementToInsert.href = link;
            elementToInsert.innerHTML = elementToTransform.innerHTML;

            elementToTransform.parentNode.insertBefore(elementToInsert, elementToTransform);
            elementToTransform.parentNode.removeChild(elementToTransform);
          }

          return (
            <Callout key={message} type="warning">
              {/* eslint-disable-next-line react/no-danger */}
              <div ref={checkLinks} dangerouslySetInnerHTML={{ __html: message }} />
            </Callout>
          );
        })}
      </div>
    </DisclaimersTeleporter.Source>
  );
}

export default DisclaimersFromTwig;
